module.exports = __webpack_public_path__ + "assets/img/left-layer-2-5fb93f45.png";